<p-breadcrumb [model]="routePath"></p-breadcrumb>
<div appAccessProvider [accessCode]="{ menuCode: 'SITES', pageCode: 'ALL', subPageCode: 'VIEW' }">
    <div class="grid mt-1 details-div border-200 mr-0">
        <div class="col-9 md:col-10  details-header-spacing">
            <app-status [dataForVehicleStatus]="" [userId]="userId"
                [entityForStatus]="entityForStatus"
                [imgFileUrl]="" [imgFileId]="" [showImage]="false"></app-status>
        </div>
        <div appAccessProvider [accessCode]="{ menuCode: 'SITES', pageCode: 'ALL', subPageCode: 'EDIT' }"
            class="col-3 text-right flex align-items-center justify-content-end details-header-space">
            @if (isDeleted) {
            <button (click)="edit()" pButton
                class="edit-btn border-400 bg-white text-color mr-1 pl-2 pr-2 pt-1 pb-1 mr-2 hover:surface-100"
                [label]="editBtnLabel">
                <i class="mi-lg mr-2 edit-pen edit_pencil"></i>
            </button>
            }
        </div>
    </div>
    <div class="flex pl-3 pr-3 pb-2 col-6">
        <div class="flex-1 mr-2">
            <p-card class="header-card cursor-pointer" (click)="navigateToProtocolTab()">
                <div class="label" translate>site.lbl_active_protocols</div>
                <div class="mt-1 text-2xl font-bold">{{entityCount?.protocol_count || 0}}</div>
            </p-card>
        </div>

        <div class="flex-1 mr-2 ml-2">
            <p-card class="header-card cursor-pointer" (click)="navigateToUserTab()">
                <div class="label" translate>site.lbl_active_users</div>
                <div class="mt-1 text-2xl font-bold">{{entityCount?.user_count || 0}}</div>
            </p-card>
        </div>
    </div>
    <p-tabView [(activeIndex)]="activeIndex" [scrollable]="true" (activeIndexChange)="activeIndexChange($event)"
        class="vehicle-detail-tab">
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="mi-lg overview"></i>
                <label class="capitalize" translate>site.lbl_overview</label>
            </ng-template>
            @if (siteDetails) {
            <router-outlet></router-outlet>
            <app-overview-details
                [attributeValues]="attributeValues"
                [attributeLabels]="attributeLabels"
                [siteAttributeData]="siteAttributeData"
                [vehicleEntityId]="vehicleId"
                [siteRowData]="currentRow"
                [siteDetails]="siteDetails"
                [driverList]="driverList"
                [isDeleted]="isDeleted"
                [isUnassigned]="isUnassigned">
            </app-overview-details>
            }
        </p-tabPanel>
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="mi-lg protocol-products"></i>
                <label class="capitalize"><span translate>site.lbl_delivery_details</span>
                    ({{entityCount?.delivery_address_count || 0}})</label>
            </ng-template>
            @if (activeIndex === 1 && isSiteReady) {
            <app-delivery-details
                [isActive]="activeIndex === 1"
                [isSiteReady]="isSiteReady"
                [siteEntityId]="siteId"
                (saveSuccess)="onDeliverySaveSuccess()">
            </app-delivery-details>
            }
        </p-tabPanel>
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="mi-lg protocol-products"></i>
                <label class="capitalize"><span translate>site.lbl_protocols</span>
                    ({{entityCount?.protocol_count || 0}})</label>
            </ng-template>
            @if (activeIndex === 2 && isSiteReady) {
            <app-site-protocols
                [isActive]="activeIndex === 2"
                [isSiteReady]="isSiteReady"
                [siteEntityId]="siteId"
                (countUpdate)="onProtocolCountUpdate($event)">
            </app-site-protocols>
            }
        </p-tabPanel>
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="mi-lg users"></i>
                <label class="capitalize"><span translate>site.lbl_users</span>
                    ({{entityCount?.user_count || 0}})</label>
            </ng-template>
            @if (activeIndex === 3 && isSiteReady) {
            <app-site-users
                [isActive]="activeIndex === 3"
                [isSiteReady]="isSiteReady"
                [siteEntityId]="siteId"
                (countUpdate)="onUserCountUpdate($event)">
            </app-site-users>
            }
        </p-tabPanel>
    </p-tabView>
</div>